/**
 * Hook into Alpine so that it is available no matter at which point Alpine loads.
 */
document.addEventListener('alpine:init', () => {
    /**
     * Manages input states across ASAPConnect.
     */
    Alpine.store('input', {
        /**
         * Set focus and the cursor on the last character of input/textarea text.
         *
         * @param {HTMLInputElement} element
         */
        setFocusAndCursorToEnd(element) {
            element.focus();
            const valueLength = element.value.length;
            this.setSelectionWithTimeout(element, valueLength, valueLength);
        },

        /**
         * Set the start and end positions of text selection with timeout.
         *
         * @param {HTMLInputElement} element
         * @param {number} start
         * @param {number} end
         * @param {number} timeout
         */
        setSelectionWithTimeout(element, start, end, timeout = 0) {
            setTimeout(() => {
                element.setSelectionRange(start, end);
            }, timeout);
        },
    });
});